import { Method } from 'axios';
import { Executable } from '../executable';
import { BambuBrandAttribute } from '../interfaces';

/**
 * The CreateBrandAttribute used by the constructor of Create Brand Attribute
 */
export class CreateBrandAttribute
  extends Executable<BambuBrandAttribute>
  implements Partial<BambuBrandAttribute>
{
  public brandId?: number;

  public name?: string;

  public description?: string;

  public required?: boolean;

  public unique_key?: boolean;

  public encrypted?: boolean;

  public searchable?: boolean;

  public dataType?: string;

  public getMethod(): Method {
    return 'post';
  }

  public getResponse(apiResponse: any): BambuBrandAttribute {
    return apiResponse;
  }

  public getURLPath(tenantId?: string): string {
    if (!this.brandId) throw new Error('brandId is required');
    return `/${this.brandId}/attributes`;
  }

  constructor(input?: Partial<BambuBrandAttribute> & { brandId: number; name: string }) {
    super();
    if (input) {
      Object.assign(this, input);
    }
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): Partial<BambuBrandAttribute> & { brandId: number; name: string } {
    if (!this.brandId) throw new Error('brandId is required');
    if (!this.name) throw new Error('name is required');
    return {
      name: this.name,
      brandId: this.brandId,
      description: this.description,
      required: this.required,
      encrypted: this.encrypted,
      searchable: this.searchable,
      dataType: this.dataType,
      unique_key: this.unique_key,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return 'brands';
  }
}
